let call_on_window = (actionData) => {
    window[actionData.function](actionData.args);
};
export default call_on_window;